import { Autocomplete, TextField } from '@mui/material';
import InputBox from 'components/form/input/InputBox';
import { PField } from 'components/form/input/NestedField';
import { fieldHasError, requiredValidator } from 'components/form/input/validator';
import React from 'react'

export default function SeletorTecnico({ name = 'tecnico', label = "Técnico", helperText, sx, required = false, possiveis = [], ...props }) {
    return (
        <InputBox sx={sx}>
            <PField
                name={name}
                validate={required ? requiredValidator : null}
            >
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta)

                    return (
                        <>
                            <Autocomplete
                                // multiple
                                options={possiveis}
                                getOptionLabel={i => i.nome || ''}
                                isOptionEqualToValue={(option, value) => option && value && option.uid === value.uid}
                                sx={{ flex: 1 }}
                                renderInput={(params) => (
                                    <TextField
                                        label={label}
                                        required={required}
                                        error={hasError}
                                        helperText={hasError ? fieldProps.meta.error : helperText}
                                        variant="standard"
                                        {...params}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                {...fieldProps.input}
                                {...props}
                                value={fieldProps.input.value || []}
                                onChange={(event, value) => {
                                    // Necessário para passar os valores do MUI para o Final Form imediatamente.
                                    fieldProps.input.onChange(value)
                                }}
                            />

                        </>
                    )
                }}
            </PField>
        </InputBox>
    )
}
